export default "__VITE_ASSET__BxO9VKtG__"